import axiosInstance from './axios'
import { errorMessageToast } from "helpers/common"
import { logout } from "store/slices/authSlice"
import apiRegistry from "utils/apiRegistry"

const axiosBaseQuery =
  ({ baseUrl } = { baseUrl: '' }) =>
    async ({ url, method, data, params, headers, signal, onUploadProgress }, { dispatch }) => {
      try {
        const result = await axiosInstance({
          url: baseUrl + url,
          method,
          data,
          params,
          headers,
          signal,
          onUploadProgress,
        })
        if (result?.status !== "success") {
          throw new Error("Response was not ok")
        }

        return {
          data: result || null,
        }
      } catch (axiosError) {
        console.log("axiosError", axiosError)
        const err = axiosError;
        if (err?.status === 401) {
          apiRegistry.forEach(api => dispatch(api.util.resetApiState()));
          dispatch(logout());
          return;
        }
        if (err.response?.data?.message) {
          errorMessageToast(err.response?.data?.message);
        }
        // Handle Network Errors (no response)
        else if (err.code === "ERR_NETWORK") {
          errorMessageToast("Network error. Please check your internet connection.", {
            toastId: "NETWORK_ERROR"
          });
        }
        return {
          error: {
            status: err.response?.status,
            data: err.response?.data || err.message,
          },
        }
      }
    }

export default axiosBaseQuery;